"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIKO = [{ deviceName: 'Wiko Sunny 3 Plus', brandName: 'Wiko', deviceCode: 'W-K200' }];
//# sourceMappingURL=wiko.js.map